var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconText = function SvgIconText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-text_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-text_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M4.167 17.5c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V4.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h11.666c.459 0 .851.163 1.177.49.327.326.49.718.49 1.177v11.666c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49H4.167Zm0-1.667h11.666V4.167H4.167v11.666Zm2.5-1.666h4.166c.236 0 .434-.08.594-.24.16-.16.24-.358.24-.594a.806.806 0 0 0-.24-.593.807.807 0 0 0-.594-.24H6.667a.806.806 0 0 0-.594.24.806.806 0 0 0-.24.593c0 .236.08.434.24.594.16.16.358.24.594.24Zm0-3.334h6.666c.236 0 .434-.08.594-.24a.803.803 0 0 0 .24-.593.806.806 0 0 0-.24-.594.806.806 0 0 0-.594-.24H6.667a.806.806 0 0 0-.594.24.806.806 0 0 0-.24.594c0 .236.08.434.24.594.16.16.358.24.594.24Zm0-3.333h6.666c.236 0 .434-.08.594-.24.16-.16.24-.357.24-.593a.806.806 0 0 0-.24-.594.806.806 0 0 0-.594-.24H6.667a.806.806 0 0 0-.594.24.806.806 0 0 0-.24.594c0 .236.08.434.24.593.16.16.358.24.594.24Z"
  }))));
};
export default SvgIconText;